module.exports = __webpack_public_path__ + "img/logo-chaleur-100-de.86bde8c1.svg";